import { ChangeDetectionStrategy, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InstallationDetailsStore } from '@store';
import { MatTooltip } from '@angular/material/tooltip';
import { matTooltipSetter } from '../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-installation-card',
  templateUrl: './installation-card.component.html',
  styleUrls: ['./installation-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationCardComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  installationId: number;

  constructor(
    private activatedRoute: ActivatedRoute,
    public installationDetailsStore: InstallationDetailsStore
  ) {}

  ngOnInit(): void {
    this.installationId = +this.activatedRoute.snapshot.params['id'];
  }
}
